import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { AgGrid, filterParams, filters, gridConstants as gc } from '../../AgGrid';
import classnames from 'classnames';

// SERVICES
import { getFieldManagers } from '../../../services';

const styles = theme => ({});

const columnDefinitions = [
  { headerName: 'Name', field: 'name' },

  {
    headerName: 'Assigned States',
    cellRenderer: params => {
      return params.data?.fieldManagerStateXref?.length;
    },
  },
];

export const FieldManagerUsersGrid = withRouter(
  withStyles(styles)(({ classes, history }) => {
    const [managerData, setManagerData] = useState(null);

    const gridOptions = {};

    const getFieldManagersAsync = async () => {
      try {
        const managers = await getFieldManagers();
        setManagerData(managers);
      } catch (err) {
        console.log(err);
      }
    };

    useEffect(() => {
      getFieldManagersAsync();
    }, []);

    return (
      <div className={classnames('flex-1', 'col-center-center')}>
        <AgGrid
          gridData={managerData}
          gridOptions={gridOptions}
          columnDefs={columnDefinitions}
          showCreateButton={true}
          handleCellClick={evt => {
            if (evt.colDef.headerName === 'Assigned States') {
              history.push({
                pathname: '/settings/field-manager-assignment',
                search: `?fieldManagerId=${evt.data.fieldManagerId}`,
              });
            }
            if (evt.colDef.field === 'name') {
              history.push(`/users/field-managers/${evt.data.fieldManagerId}`);
            }
          }}
          redirectOnClick={true}
        />
      </div>
    );
  }),
);